import { AppointmentEncounterMode } from '@dreryk/egabinet-appointment-frontend-api';

import { Dropdown, LinkIconVariant, LinkVariant } from '@dreryk/react-components';

import {
   useAppointmentEncounterModeDropdownItemsConfiguration,
   useAppointmentUpdateEncounterModeCommand,
} from './AppointmentEncounterModeDropdown.hooks';
import { AppointmentEncounterModeIcon } from './AppointmentEncounterModeIcon';

type AppointmentEncounterModeDropdownProps = Readonly<{
   appointmentId: number;
   encounterMode: AppointmentEncounterMode;
}>;

export const AppointmentEncounterModeDropdown = (props: AppointmentEncounterModeDropdownProps): JSX.Element => {
   const { executeAsync: updateAppointmentEncounterMode } = useAppointmentUpdateEncounterModeCommand({
      appointmentId: props.appointmentId,
   });

   const dropdownItemsConfiguration = useAppointmentEncounterModeDropdownItemsConfiguration({
      onUpdateAppointmentEncounterMode: updateAppointmentEncounterMode,
   });

   const selectedDropdownItem = dropdownItemsConfiguration[props.encounterMode];

   return (
      <Dropdown
         testId={'appointmentEncounterMode'}
         triggerLabel={selectedDropdownItem.label}
         triggerIcon={<AppointmentEncounterModeIcon icon={selectedDropdownItem.icon} />}
         variant={LinkVariant.STANDARD}
         triggerIconSuffixVariant={LinkIconVariant.PRIMARY}
         maxWidth={176}
      >
         {Object.entries(dropdownItemsConfiguration).map(([, dropdownItem]) => dropdownItem.item)}
      </Dropdown>
   );
};
